interface StatusPillProps {
  label: string;
  color: string;
  className?: string;
}

/**
 * Small "build status" style badge - a pulsing dot in the project's accent
 * color plus a monospace label. Used on the gallery card (top-left of the
 * media) and again in the detail page's terminal-chrome hero bar, so the two
 * pages read as one continuous system.
 */
export function StatusPill({ label, color, className = "" }: StatusPillProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border border-border/60 bg-background/80 px-2.5 py-1 font-mono text-[10px] uppercase tracking-wider text-foreground backdrop-blur-sm ${className}`}
    >
      <span className="relative flex h-1.5 w-1.5">
        <span
          className="absolute inline-flex h-full w-full animate-ping rounded-full opacity-75 motion-reduce:animate-none"
          style={{ backgroundColor: color }}
        />
        <span className="relative inline-flex h-1.5 w-1.5 rounded-full" style={{ backgroundColor: color }} />
      </span>
      {label}
    </span>
  );
}